import React, { useState } from 'react';
import { analytics } from '../../firebase/clientApp';
import { logEvent } from 'firebase/analytics';
import { functions } from '../../firebase/clientApp';
import { httpsCallable } from 'firebase/functions';
import { TextLoader } from '.';
import { toast } from 'react-hot-toast';
import classNames from '../utility/classNames';

export default function WaitlistForm({ isHeroSection = true }) {
  const [userEmail, setUserEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);

    try {
      const onAddToWaitlist = httpsCallable(functions, 'onAddToWaitlist');
      const response = await onAddToWaitlist({ userEmail });

      if (!response) {
        throw new Error('Failed to subscribe');
      } else {
        logEvent(analytics, 'generate_lead', {
          firebase_screen: 'landing_page',
          firebase_screen_class: 'marketing',
          content_type: 'newsletter',
        });

        setSubmitting(false);
        setUserEmail('');
        return toast.success('Thank you for joining the waitlist!', {
          position: 'top-right',
        });
      }
    } catch (httpsError) {
      setSubmitting(false);

      const { code } = httpsError;

      switch (code) {
        case 'functions/already-exists':
          return toast.error('This email is already on the waitlist', {
            position: 'top-right',
          });
        case 'functions/permission-denied':
          return toast.error(
            'You have been granted access. Sign in to view your account.',
            {
              position: 'top-right',
            }
          );
        default:
          console.error(httpsError);
          return toast.error('Something went wrong', { position: 'top-right' });
      }
    }
  };

  return (
    <form
      onSubmit={(e) => handleSubmit(e)}
      className={classNames(
        'mt-4 sm:w-full sm:flex',
        isHeroSection && 'sm:mt-12 sm:max-w-lg'
      )}
    >
      <div className="min-w-0 flex-1">
        <label htmlFor="hero-email" className="sr-only">
          Email address
        </label>
        <input
          id="hero-email"
          type="email"
          required
          className={classNames(
            'block w-full border border-neutral-300 rounded-md  text-neutral-900 placeholder-neutral-500 shadow-sm transition focus:border-primary focus:ring-primary',
            isHeroSection ? 'text-base px-5 py-3' : 'text-base px-3 py-2'
          )}
          placeholder="Enter your email"
          value={userEmail}
          onChange={(e) => setUserEmail(e.currentTarget.value)}
        />
      </div>
      <div className="mt-4 sm:mt-0 sm:ml-3">
        <button
          type="submit"
          className={classNames(
            'min-w-[120px] block w-full h-full rounded-md border border-transparent bg-primary font-medium text-white shadow transition hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 sm:px-10',
            isHeroSection ? 'text-base px-5 py-3' : 'text-base px-3 py-2'
          )}
        >
          {submitting ? <TextLoader color="white" /> : 'Join Waitlist'}
        </button>
      </div>
    </form>
  );
}
